import { fetchHTML } from './utils-fetch-html.js';

class CartItemCount extends HTMLElement {
  connectedCallback() {
    this.unsubscribeCartAdded = subscribe('cart:added', () => this.addCartCount());
    this.unsubscribeCartUpdated = subscribe('cart:updated', () => this.addCartCount());
    this.unsubscribeCartAddOnsUpdated = subscribe('cart-add-ons:updated', () =>
      this.addCartCount()
    );
  }

  disconnectedCallback() {
    this.unsubscribeCartAdded();
    this.unsubscribeCartUpdated();
    this.unsubscribeCartAddOnsUpdated();
  }

  /**
   * Add cart count
   */
  async addCartCount() {
    try {
      const html = await fetchHTML(`${Shopify.routes.root}?section_id=fetch-cart-item-count`);
      const target = html.querySelector('cart-item-count');
      this.replaceWith(target);
    } catch (error) {
      console.log(error.message);
    }
  }
}

customElements.define('cart-item-count', CartItemCount);
